import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '../../../contexts/AuthContext';

/**
 * Landing page for the Microsoft SSO redirect.
 * The backend redirects here with ?token=<JWT> after successful authentication.
 */
export function AuthCallbackPage() {
  const { receiveToken } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (!token) {
      navigate('/login', { replace: true });
      return;
    }

    try {
      receiveToken(token);
      navigate('/employee/entries', { replace: true });
    } catch {
      navigate('/login', { replace: true });
    }
  }, [receiveToken, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <p className="text-muted-foreground text-sm">Signing you in…</p>
    </div>
  );
}
